import AppPage from "layouts/AppPage";
import { useParams, useSearchParams } from "react-router";
import { useMessageTemplateDetailQuery } from "features/Resources/MessageTemplate/hooks";
import MessageTemplateForm from "features/Resources/MessageTemplate/Layout/MessageTemplateForm";
import { usePrebuiltMessageTemplateDetailQuery } from "features/Prebuilt/PrebuiltSharedTemplate/hooks";
import PrebuiltMessageTemplateDisplay from "features/Resources/MessageTemplate/Layout/PrebuiltMessageTemplateDisplay";
import { useMemo } from "react";
import CaminoBreadcrumbs from "components/Breadcrumbs";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";
import { truncateEnd } from "helpers/string";

export default function MessageTemplatePage() {
  const { id } = useParams<{ id: string; }>();
  const [searchParams] = useSearchParams();
  const { data, isLoading } = useMessageTemplateDetailQuery(id, {
    enabled: !!id && id !== "new",
  });
  const pathId = searchParams.get("pathId") ?? undefined;

  const formData = useMemo(() => {
    if (id === "new" && pathId) {
      return { paths: [{ id: pathId }] };
    }
    return data || {};
  }, [id, pathId, data]);

  if (!id) {
    // TODO: Redirect to 404
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      <CaminoBreadcrumbs
        breadcrumbInfos={[
          { name: "Message Templates", toUrl: PEOPLE_TEAM_ROUTES.messageTemplates.index },
          { name: id === "new" ? "New" : `${truncateEnd(data?.name)}` },
        ]}
      />
      {(data || id === "new") && (
        <MessageTemplateForm id={id} data={formData} />
      )}
    </AppPage>
  );
}

export function PrebuiltMessageTemplatePage() {
  const { id } = useParams<{ id: string; }>();
  const { data, isLoading } = usePrebuiltMessageTemplateDetailQuery(id!);

  if (!id) {
    // TODO: Redirect to 404
    return <AppPage>Template not found</AppPage>;
  }

  if (isLoading) {
    return <AppPage>Loading...</AppPage>;
  }

  return (
    <AppPage>
      {data && (
        <PrebuiltMessageTemplateDisplay prebuiltMessageTemplate={data} />
      )}
    </AppPage>
  );
}
